export default [
  {
    path: "/users",
    component: () => import(/* webpackChunkName: "users" */ "./layout"),

    children: [
      {
        path: "/",
        name: "users",
        component: () => import(/* webpackChunkName: "users" */ "./all"),
      },
      {
        path: "whitelisted/countryhighrisk",
        component : () => import(/* webpackChunkName: "users.whitelisted" */ "./whitelisted")
      },
      {
        path: ":id",
        props: true,
        name: "users.show",
        component: () => import(/* webpackChunkName: "users.show" */ "./show"),
      },
    ],
  },
];
